// frontend/src/router/routes/providerRoutes.tsx
// FIXED: Removed /profile route to prevent conflicts (handled in main router)

import { Route } from "react-router-dom";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import ProviderSetup from "@/pages/ProviderSetup";
import BusinessProfile from "@/pages/BusinessProfile";


export const providerRoutes = [
  // =====================================
  // 🔷 PROVIDER SETUP & PROFILE ROUTES
  // =====================================
  <Route
    key="provider-setup"
    path="/setup"
    element={
      <ProtectedRoute requiredRoles={["provider"]} layout="provider">
        <ProviderSetup />
      </ProtectedRoute>
    }
  />,
  
  // 🔷 BUSINESS PROFILE - Provider-specific business profile
  <Route
    key="provider-business-profile"
    path="/business-profile"
    element={
      <ProtectedRoute requiredRoles={["provider"]} layout="provider">
        <BusinessProfile />
      </ProtectedRoute>
    }
  />,
  
  // =====================================
  // 🔷 PROVIDER MANAGEMENT ROUTES
  // =====================================


  // NOTE: /profile route is handled in the main router to prevent conflicts
  // NOTE: All booking routes have been moved to bookingRoutes.tsx
];